(() => {
  if (!location.pathname.includes('/products/')) return;
  const root = document.documentElement;
  const surfaceSelector = 'm-cart-drawer, #m-menu-drawer, m-search-popup, .m-modal, pickup-availability-drawer .m-drawer__wrapper, dialog';
  const activeSelector = '.m-cart-drawer--active, #m-menu-drawer.open, m-search-popup[open], .m-modal, pickup-availability-drawer .m-drawer__wrapper.mobile:not(.m\\:hidden), dialog[open]';
  let owned = false;
  let queued = false;
  function reconcile(recover = false) {
    const active = Array.from(document.querySelectorAll(activeSelector)).some(el => el.getClientRects().length);
    if (active) {
      owned = true;
      if (!root.classList.contains('prevent-scroll')) root.classList.add('prevent-scroll');
    } else if (owned || recover) {
      owned = false;
      root.classList.remove('prevent-scroll');
    }
  }
  const observer = new MutationObserver(records => {
    const relevant = records.some(record => record.target === root || record.target.matches?.(surfaceSelector) ||
      Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node.matches?.(surfaceSelector) || node.querySelector?.(surfaceSelector)));
    if (!relevant || queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; reconcile(); });
  });
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'hidden'] });
  observer.observe(root, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('pageshow', event => reconcile(event.persisted));
  reconcile();
})();
